import FullPageLoader from "@/components/Common/FullPageLoader";
import NotFound from "@/components/Common/NotFound";
import {useIsAdmin, useUserId} from "@/hooks/useUserHooks";
import {createFileRoute, Outlet} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_admin")({
  component: Admin,
});

function Admin() {
  const isAdmin = useIsAdmin();
  const userId = useUserId();

  if (!userId) {
    return <FullPageLoader />;
  }

  if (!isAdmin) {
    return <NotFound />;
  }

  return <Outlet />;
}
